import { createMarketplaceHttpClient } from "../marketplaceHttpClient";
import { negotiationApiOf } from "../negotiation/negotiationPayload";

/**
 * Offres de production des producteurs (page /producers) et demandes de culture en prévente.
 *
 *   Navigateur :3000 → Gateway :8080 → agri-product-platform :1997
 *   GET  /marketplace/production-offers?country=TG&subCategory=&page=&size=   public, sans JWT
 *   POST /marketplace/production-offers/{id}/presale-requests?country=TG      utilisateur connecté
 *   GET  /marketplace/presale-requests/sent?country=TG                        utilisateur connecté
 *   POST /marketplace/presale-requests/{id}/withdraw?country=TG               utilisateur connecté
 *   …    /marketplace/presale-requests/{id}/negotiation?country=TG            utilisateur connecté
 *
 * `country` est le pays de l'offre (pays d'activité choisi sur le site) : la demande est
 * enregistrée dans la base de ce pays. Prix et devise viennent du backend (devise du pays du
 * producteur) ; le frontend ne connaît aucun prix.
 */
// La liste publique n'envoie jamais de JWT : un jeton expiré la ferait échouer en 401.
const publicApi = createMarketplaceHttpClient({ authenticated: false });
const api = createMarketplaceHttpClient();

/** @param {{country: string, subCategory?: string, page?: number, size?: number}} query */
export const listProductionOffers = async ({ country, subCategory, page = 0, size = 12 }) => {
    const { data } = await publicApi.get("/marketplace/production-offers", {
        params: { country, subCategory: subCategory || undefined, page, size }
    });
    return {
        items: data?.items || [],
        page: data?.page ?? page,
        size: data?.size ?? size,
        total: data?.total ?? 0
    };
};

/**
 * @param {{fullName: string, companyName?: string, telephone?: string, email?: string,
 *          requestedQuantity: number, desiredDeliveryDate?: string, message?: string}} request
 */
export const requestPresale = async (country, offerId, request) => {
    const { data } = await api.post(`/marketplace/production-offers/${offerId}/presale-requests`, request, {
        params: { country }
    });
    return data;
};

export const listSentPresaleRequests = async (country) => {
    const { data } = await api.get("/marketplace/presale-requests/sent", { params: { country } });
    return Array.isArray(data) ? data : [];
};

export const withdrawPresaleRequest = async (country, requestId) => {
    const { data } = await api.post(`/marketplace/presale-requests/${requestId}/withdraw`, null, {
        params: { country }
    });
    return data;
};

/** Négociation d'une demande envoyée (voir negotiationPayload). */
export const presaleNegotiationApi = negotiationApiOf(api, "/marketplace/presale-requests");

const presaleApi = { listProductionOffers, requestPresale, listSentPresaleRequests, withdrawPresaleRequest };

export default presaleApi;
